export default "__VITE_ASSET__DVRwRQvj__"